"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketParser = void 0;
// Header 길이는 48자로 고정
const SERVICE_1 = require("../constants/SERVICE");
const HEADER_LENGTH = 48;
const HEADER_FIELDS = [
    { key: 'CLASSIFICATION_CODE', length: 2 },
    { key: 'PROGRESS_CODE', length: 2 },
    { key: 'LOGIN_DATE', length: 14 },
    { key: 'TRANSMISSION_CODE', length: 3 },
    { key: 'RECEIVE_CODE', length: 3 },
    { key: 'SENDING_DATE', length: 14 },
    { key: 'DATA_LENGTH', length: 10 },
];
const BODY_FIELDS = {
    [SERVICE_1.SERVICE.ST331]: [
        "TRANSMISSION_NUMBER",
        "EVENT_NAME",
        "SECONDARY_EVENT_NAME",
        "LONGITUDE",
        "LATITUDE",
        "OCCURRENCE_LOCATION",
        "DESIGNATED_LAW_CODE",
        "OCCURRENCE_DATE",
        "SENDER_ID",
        "END", // END(세미콜론)
    ],
    [SERVICE_1.SERVICE.SD332]: [],
    [SERVICE_1.SERVICE.ST333]: [
        "NUMBER",
        "SERVICE_TYPE",
        "LONGITUDE",
        "LATITUDE",
        "OCCURRENCE_LOCATION",
        "DESIGNATED_LAW_CODE",
        "Ref_ID",
        "NAME",
        "PHONE",
        "BIRTH",
        "GENDER",
        "ADDRESS",
        "PROTECTOR_NAME",
        "PROTECTOR_PHONE",
        "OCCURRENCE_DATE",
        "IMAGE",
        "PERSONAL_INFORMATION",
        "NOTE",
        "SENDER_ID",
        "END", // END(세미콜론)
    ],
    [SERVICE_1.SERVICE.SH334]: [''],
    [SERVICE_1.SERVICE.ST335]: [
        "CASE_NUMBER",
        "ACCIDENT_GRADE",
        "ACCIDENT_TYPE",
        "LONGITUDE",
        "LATITUDE",
        "OCCURRENCE_LOCATION",
        "DESIGNATED_LAW_CODE",
        "OCCURRENCE_DATE",
        "SENDER_ID",
        "END", // END(세미콜론)
    ],
};
class SocketParser {
    static parseBody(service, data) {
        return BODY_FIELDS[service].reduce((acc, key, index) => {
            return Object.assign(Object.assign({}, acc), { [key]: data[index] });
        }, {});
    }
    static parseHeader(data) {
        return HEADER_FIELDS.reduce((acc, field) => {
            return Object.assign(Object.assign({}, acc), { [field.key]: data.splice(0, field.length).join('') });
        }, {});
    }
    static parse(service, data) {
        const header = data.slice(0, HEADER_LENGTH).split('');
        const body = data.slice(HEADER_LENGTH, data.length).split('\x1E').join('\x1F').split('\x1F');
        return {
            header: SocketParser.parseHeader(header),
            body: SocketParser.parseBody(service, body),
        };
    }
}
exports.SocketParser = SocketParser;
